import React from 'react';

const SignUpForm = (): JSX.Element => {
  return (
    <div className="tablet:grid-col-4">
      <div className="usa-sign-up">
        <h3 className="usa-sign-up__heading">Sign up</h3>
        <form className="usa-form">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="usa-label" htmlFor="email">
            Your email address
          </label>
          <input className="usa-input" id="email" name="email" type="email" />
          <button className="usa-button" type="submit">
            Sign up
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignUpForm;
